import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ranking from "./components/Ranking";
import Categories from "./components/Categories";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { faqs } from "@/mocks/comicData";

const faqStructured = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.a,
    },
  })),
};

const orgStructured = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "漫阅指南",
  description: "精选正版国漫、日漫、韩漫、美漫阅读平台推荐与追更攻略资讯站。",
  url: "https://comixgo1.github.io/",
};

const siteStructured = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "漫阅指南",
  url: "https://comixgo1.github.io/",
  description: "漫画阅读软件推荐与正版追更攻略。",
  inLanguage: "zh-CN",
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgStructured) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(siteStructured) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructured) }} />

      <Navbar />
      <main>
        <Hero />
        <Ranking />
        <Categories />
        <Guide />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
}